<template>
    <div class="flatpickr">
        <input ref="picker" :value="value" @input="valueChanged($event.target.value)" :placeholder="schema.placeholder" :disabled="disabled">
        <div v-if="value" class="flatpickr__clear" @mousedown.stop.prevent="clearValue"></div>
    </div>
</template>

<script>
import 'flatpickr/dist/themes/light.css';
import format from 'date-fns/format';
import { abstractField } from 'vue-form-generator';
import Flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';

export default {
    name: 'flatpickr',
    mixins: [abstractField],
    data() {
        return {
            fp: null,
            config: {
                allowInput: true,
                enableTime: true,
                dateFormat: 'd/m/Y H:i',
                mode: 'single',
                noCalendar: false,
                time_24hr: true,
                utc: false,
                wrap: false
            },
            watchMinDate: null,
            watchMaxDate: null
        };
    },
    computed: {
        options() {
            return this.schema.flatpickrOptions;
        },
        minDate() {
            console.log('minDate');
            if (this.options && this.options.minDate) {
                let value;
                if (typeof this.options.minDate === 'boolean') {
                    value = format(new Date(), 'YYYY-MM-DD HH:mm');
                } else {
                    value = this.model[this.options.minDate];
                }
                this.fp.set('minDate', value);
                return value;
            }
        }
    },
    watch: {
        value: function(val, oldVal) {
            // console.log('watch value', val, oldVal, typeof val, typeof oldVal);
            if (typeof val === 'undefined') {
                this.clearValue();
            }
        }
    },
    methods: {
        valueChanged(value) {
            // console.log('valueChanged', value);
            this.value = value;
        },
        clearValue() {
            if (this.fp) {
                this.value = undefined;
                this.fp.clear();
            }
        },
        formatValueToField(value) {
            // console.log('formatValueToField', value, typeof value, this.$el);
            if (typeof value !== 'undefined') {
                if (value && this.fp && this.$el && this.$el.firstChild.value.length === 0) {
                    this.fp.setDate(value);
                }
                return value;
            }
        },
        formatValueToModel(value) {
            // console.log('formatValueToModel', value);
            return value;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.config.locale = French;

            switch (this.options.type) {
                case 'date':
                    this.config = Object.assign(this.config, {
                        altFormat: 'd/m/Y',
                        altInput: true,
                        enableTime: false,
                        dateFormat: 'Y-m-d',
                        noCalendar: false
                    });
                    break;
                case 'datetime':
                    this.config = Object.assign(this.config, {
                        altFormat: 'd/m/Y H:i',
                        altInput: true,
                        enableTime: true,
                        dateFormat: 'Y-m-d H:i',
                        noCalendar: false,
                        defaultHour: new Date().getHours(),
                        defaultMinute: new Date().getMinutes()
                    });
                    break;
                case 'time':
                    this.config = Object.assign(this.config, {
                        altFormat: 'h:i:s',
                        altInput: false,
                        enableTime: true,
                        dateFormat: 'H:i',
                        noCalendar: true,
                        defaultHour: new Date().getHours(),
                        defaultMinute: new Date().getMinutes()
                    });
                    break;
                default:
                    break;
            }

            this.fp = new Flatpickr(this.$refs.picker, this.config);

            if (this.options.minDate) {
                if (typeof this.options.minDate === 'boolean') {
                    this.fp.set('minDate', format(new Date(), 'YYYY-MM-DD HH:mm'));
                } else {
                    this.fp.set('minDate', this.model[this.options.minDate]);
                    this.watchMinDate = this.$watch(
                        function() {
                            return this.model[this.options.minDate];
                        },
                        function(newVal, oldVal) {
                            this.fp.set('minDate', newVal);
                        }
                    );
                }
            }

            if (this.options.maxDate) {
                if (typeof this.options.maxDate === 'boolean') {
                    this.fp.set('maxDate', format(new Date(), 'YYYY-MM-DD HH:mm'));
                } else {
                    this.fp.set('maxDate', this.model[this.options.maxDate]);
                    this.watchMaxDate = this.$watch(
                        function() {
                            return this.model[this.options.maxDate];
                        },
                        function(newVal, oldVal) {
                            this.fp.set('maxDate', newVal);
                        }
                    );
                }
            }
        });
    },
    beforeDestroy() {
        if (this.watchMinDate) {
            this.watchMinDate();
        }
        if (this.watchMaxDate) {
            this.watchMaxDate();
        }
        this.fp.destroy();
    }
};
</script>

<style lang="scss" scoped>
.flatpickr {
    position: relative;
    &__clear {
        top: 0;
        bottom: 0;
        position: absolute;
        right: 0;
        height: 42px;
        width: 42px;
        display: block;
        cursor: pointer;
        z-index: 2;
        &:before,
        &:after {
            content: '';
            display: block;
            position: absolute;
            width: 3px;
            height: 16px;
            background: #aaa;
            top: 13px;
            right: 21px;
        }
        &:before {
            transform: rotate(45deg);
        }
        &:after {
            transform: rotate(-45deg);
        }
    }
}
</style>
